import { create } from 'zustand';

import { GetTickets } from '../api';

import { resetTablePage } from './use-table-pagination-store';
import { omit } from '@/utils';

type GetTableParam = GetTickets['param'];

export type UseTableFilterStore = {
  userId: string;
  searchString: GetTableParam['searchString'];
  status: GetTableParam['status'];
};

const defaultValue: UseTableFilterStore = {
  userId: '',
  searchString: '',
  status: [],
};

export const useTableFilterStore = create<UseTableFilterStore>(() => ({
  ...defaultValue,
}));

export const useSearchFilter = () =>
  useTableFilterStore((state) => state.searchString);

export const useStatusFilter = () =>
  useTableFilterStore((state) => state.status);

export const useTableFilter = () => useTableFilterStore((state) => state);

export const setSearchStringFilter = (
  searchString: UseTableFilterStore['searchString'],
) => {
  useTableFilterStore.setState({ searchString });
  resetTablePage();
};

export const setStatusFilter = (status: UseTableFilterStore['status']) => {
  useTableFilterStore.setState({ status });
  resetTablePage();
};

export const resetHiddenFilters = () => {
  useTableFilterStore.setState({
    ...omit(defaultValue, ['searchString']),
  });
};

export const resetUsersFilterStore = () => {
  useTableFilterStore.setState({ ...defaultValue });
  resetTablePage();
};
